export enum SignCollectStatus {
  unknown = 'unknown',
  complete = 'complete',
  usersign = 'usersign',
  outstandingtransaction = 'outstandingtransaction',
  noclient = 'noclient',
  started = 'started',
}

export class SignCollectStatusHelper {
  public static parse(value: string): SignCollectStatus {
    if (value in SignCollectStatus) {
      return SignCollectStatus[value as keyof typeof SignCollectStatus];
    }
    return SignCollectStatus.unknown;
  }
}
